import { render, staticRenderFns } from "./InvestorProfileV3.vue?vue&type=template&id=9860d908&scoped=true&"
import script from "./InvestorProfileV3.vue?vue&type=script&lang=js&"
export * from "./InvestorProfileV3.vue?vue&type=script&lang=js&"
import style0 from "./InvestorProfileV3.vue?vue&type=style&index=0&id=9860d908&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9860d908",
  null
  
)

export default component.exports